import { useEffect, useState } from "react";
import { useSocket, useUnseenCount } from "@novu/notification-center";
import useGetExpiredMessages from "./useGetExpiredMessages";

export default function useGetUnseenCount(): [
  number,
  React.Dispatch<React.SetStateAction<number>>
] {
  const [count, setCount] = useState<number>(0);

  // useGetExpiredMessages();
  const { data } = useUnseenCount({
    refetchOnMount: true
  });

  const { socket } = useSocket();

  useEffect(() => {
    if (socket) {
      socket.on("unseen_count_changed", ({ unseenCount }) => {
        setCount(unseenCount);
      });
    }
  }, [socket]);

  useEffect(() => {
    if (data) {
      setCount(data.count);
    }
  }, [data]);

  // console.log(count);
  return [count, setCount];
}
